import * as actionTypes from '../actions/actionTypes';

export const MLAInitialState = {
  unitMLA: [],
  loading: false,
  loaded: false,
  error: null
};

const reducer = (state = MLAInitialState, action) => {
  switch (action.type) {
    case actionTypes.GET_UNIT_MLA_START:
      return {
        ...state,
        loading: true
      };
    case actionTypes.GET_UNIT_MLA_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        unitMLA: action.unitMLA
      };
    case actionTypes.GET_UNIT_MLA_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.error
      };
    case actionTypes.RESET_MLA_STATE:
      return MLAInitialState;
    default:
      return state;
  }
};

export default reducer;
